export default (axios) => ({
    postLiveCart: (data) => axios.post('/amusement/add-shop-live-cart', data).then((_) => _.data),
    getIndexLive: (data) => axios.post('/amusement/get-shop-live-product', data).then((_) => _.data),
    getSessions: (data) => axios.get('/amusement/list-session', data).then((_) => _.data),
});
